"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findTempStorageKey = exports.findClaimStatusKey = exports.findDistributorKey = void 0;
const tslib_1 = require("tslib");
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const findDistributorKey = (base) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([anchor_1.utils.bytes.utf8.encode("MerkleDistributor"), base.toBytes()], constants_1.PROGRAM_ID);
});
exports.findDistributorKey = findDistributorKey;
const findClaimStatusKey = (index, distributor) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("ClaimStatus"),
        index.toArrayLike(Buffer, "le", 8),
        distributor.toBytes(),
    ], constants_1.PROGRAM_ID);
});
exports.findClaimStatusKey = findClaimStatusKey;
const findTempStorageKey = (index, claimant, distributor) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("TempStorage"),
        index.toArrayLike(Buffer, "le", 8),
        distributor.toBytes(),
        claimant.toBytes(),
    ], constants_1.PROGRAM_ID);
});
exports.findTempStorageKey = findTempStorageKey;
//# sourceMappingURL=pda.js.map